module.exports = __webpack_public_path__ + "img/logo-login.230dc16c.png";